import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Storefront breadcrumb trail with matching JSON-LD structured data
 * so Google can show a clean path in search results.
 *
 *   items: [{ label, to? }] — last entry is the current page (no link)
 */
export default function Breadcrumbs({ items }) {
  if (!items || items.length === 0) return null;

  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((it, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: it.label,
      ...(it.to ? { item: `${origin}${it.to}` } : {}),
    })),
  };

  return (
    <>
      <nav aria-label='Breadcrumb' style={{ fontSize: 12, color: '#64748b', margin: '0 0 12px' }}>
        {items.map((it, i) => {
          const isLast = i === items.length - 1;
          return (
            <React.Fragment key={`${it.label}-${i}`}>
              {it.to && !isLast ? (
                <Link to={it.to} style={{ color: '#475569', textDecoration: 'none' }}>
                  {it.label}
                </Link>
              ) : (
                <span aria-current={isLast ? 'page' : undefined} style={{ color: isLast ? '#0f172a' : '#64748b', fontWeight: isLast ? 600 : 400 }}>
                  {it.label}
                </span>
              )}
              {!isLast && <span style={{ margin: '0 6px', color: '#cbd5e1' }}>/</span>}
            </React.Fragment>
          );
        })}
      </nav>
      <script
        type='application/ld+json'
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
    </>
  );
}
